module.exports = require('./dist/core').default
